import React, { ComponentProps, ComponentType } from 'react';

// eslint-disable-next-line
type TypedComponentType = ComponentType<any>;
type PropTypes<T extends TypedComponentType> = ComponentProps<T>;
/**
 * This is a wrapper Higher Order Component with type safety for React.memo.
 * https://reactjs.org/docs/react-api.html#reactmemo
 *
 * This was required to successfully use React.memo with TS as the prop types on
 * the child Component were not being passed to react memo and causing compilation errors
 */
const Memo: <T extends TypedComponentType>(
  Component: T,
  propsAreEqual?: (prevProps: PropTypes<T>, nextProps: PropTypes<T>) => boolean,
) => T = React.memo;

export default Memo;
